import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { translate } from '@haldor/ui';
import { clearVerdicts, getVerdictScale } from 'actions/verdicts';
import VerdictFeedbackForm from 'containers/Verdict/Form/Partials/VerdictFeedbackForm';
import VerdictLevelForm from 'containers/Verdict/Form/Partials/VerdictLevelForm';
import { Icon, Button, TooltipMenu } from '@haldor/ui';

var MultipleVerdictForm = /*#__PURE__*/function (_Component) {
  _inherits(MultipleVerdictForm, _Component);

  var _super = _createSuper(MultipleVerdictForm);

  function MultipleVerdictForm(props) {
    var _this;

    _classCallCheck(this, MultipleVerdictForm);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      if (_this.props.scale == null) {
        _this.props.getVerdictScale().then(function () {
          _this.setState({
            loading: false
          });
        });
      } else {
        _this.setState({
          loading: false
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "removeStudent", function (student) {
      if (_this.props.onRemoveStudent != null) {
        _this.props.onRemoveStudent(student);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "abort", function (event) {
      event.preventDefault();

      _this.props.onAbort();
    });

    _defineProperty(_assertThisInitialized(_this), "submit", function (values) {
      return new Promise(function (resolve) {
        var data = [];

        _this.props.students.forEach(function (student) {
          data.push({
            scaleLevelId: _this.state.level,
            feedback: _this.state.feedback,
            scaleId: _this.props.scale.id,
            status: 'VERDICT_DRAFT',
            userId: student.id
          });
        });

        if (_this.props.onSubmit != null) {
          _this.props.onSubmit(data).then(function () {
            resolve(1);
          });
        } else {
          resolve(1);
        }
      });
    });

    _this.state = {
      level: '0',
      feedback: '',
      loading: true
    };
    return _this;
  }

  _createClass(MultipleVerdictForm, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          submitting = _this$props.submitting,
          handleSubmit = _this$props.handleSubmit;
      var _this$state = this.state,
          feedback = _this$state.feedback,
          level = _this$state.level,
          loading = _this$state.loading;

      if (loading) {
        return /*#__PURE__*/React.createElement("div", null);
      }

      return /*#__PURE__*/React.createElement("div", null, submitting ? /*#__PURE__*/React.createElement("div", {
        className: "is_sending",
        style: {
          height: '100%',
          top: 0
        }
      }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("span", {
        className: "loading-spinner"
      }))) : null, /*#__PURE__*/React.createElement("div", {
        className: "form-container"
      }, /*#__PURE__*/React.createElement("form", {
        onSubmit: handleSubmit(this.submit),
        className: "form form-component"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "verdict verdict-users-list"
      }, this.props.translate('students'), this.props.students.map(function (student) {
        var dropdownTrigger = /*#__PURE__*/React.createElement("div", {
          className: "dropdown--trigger"
        }, /*#__PURE__*/React.createElement(Icon, {
          name: "Bullets"
        }));
        return /*#__PURE__*/React.createElement("div", {
          className: "verdict-user",
          key: student.id
        }, /*#__PURE__*/React.createElement("div", {
          className: "name"
        }, student.firstName, " ", student.lastName), /*#__PURE__*/React.createElement(TooltipMenu, {
          trigger: dropdownTrigger
        }, /*#__PURE__*/React.createElement(TooltipMenu.Item, {
          onClick: function onClick() {
            return _this2.removeStudent(student);
          }
        }, _this2.props.translate('Delete'))));
      }))), /*#__PURE__*/React.createElement("div", {
        className: "form-row",
        style: {
          marginTop: '1.55rem'
        }
      }, this.props.translate('verdicts'), this.props.scale != null ? /*#__PURE__*/React.createElement(VerdictLevelForm, {
        levels: this.props.scale.levels,
        value: level,
        onChange: function onChange(level) {
          return _this2.setState({
            level: level
          });
        },
        key: this.props.scale.id
      }) : null), /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement(VerdictFeedbackForm, {
        value: this.state.feedback,
        onChange: function onChange(feedback) {
          return _this2.setState({
            feedback: feedback
          });
        }
      })), /*#__PURE__*/React.createElement("div", {
        className: "form-row submit",
        style: {
          marginTop: '1.25rem',
          marginBottom: '1.25rem'
        }
      }, /*#__PURE__*/React.createElement(Button, {
        disabled: level == 0 || level == null || submitting
      }, this.props.translate('save-verdicts')), /*#__PURE__*/React.createElement("div", {
        className: "align-right"
      }, /*#__PURE__*/React.createElement(Button, {
        onClick: this.abort,
        type: "secondary"
      }, this.props.translate('Cancel'))), /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      })))));
    }
  }]);

  return MultipleVerdictForm;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    scale: state.Verdicts.scale
  };
}

export default connect(mapStateToProps, {
  getVerdictScale: getVerdictScale,
  clearVerdicts: clearVerdicts
}, null, {
  pure: false
})(reduxForm({
  form: 'MultipleVerdictForm',
  destroyOnUnmount: true
})(MultipleVerdictForm));